import { SUGGESTED_ANSWER_VARY } from 'global/constants';
import SubActivityView from '../../sub-activity/sub-activity-view';
import ActivitySheet from '../../shared/sheet/activity-sheet';
import ActivitySheetSaveStatus from '../../shared/sheet/activity-sheet-save-status';
import {
  ActivitySheetGridMax,
  ActivitySheetInnerContent,
  ActivitySheetInnerMax,
} from '../../shared/sheet/activity-sheet.style';
import { ClassroomAnswerInstruction } from '../../../classroom/classroom-answer.style';
import ClassroomAnswerTabs, {
  INDIVIDUAL_VIEW,
  QUESTION_VIEW,
  SUGGESTED_VIEW,
} from 'approot/activity-builder/classroom/classroom-answer-tabs';
import useInitialClassroomTab from 'approot/activity-builder/classroom/use-initial-classroom-tab';
import FillInBlanksViewRespond from './fill-in-blanks-view-respond';
import FillInBlanksIndividual from './fill-in-blanks-individual';
import FillInBlanksSuggestedAnswers from './fill-in-blanks-suggested-answers';
import { ViewProps } from '../fill-in-blanks.constants';

type Props = ViewProps & {
  onClose: () => void;
};

const FillInBlanksClassAnswers = (props: Props) => {
  const {
    subActivityProperties,
    suggestedAnswerProperties,
    id,
    type,
    onClose,
  } = props;

  const { tab, setTab } = useInitialClassroomTab({
    isVisible: true,
    canRespond: true,
    componentId: id,
  });

  return (
    <ActivitySheet
      isVisible
      title="Fill in the Blanks"
      hasBackgroundColor={tab === QUESTION_VIEW}
      customActions={
        <ActivitySheetSaveStatus
          title="Fill in the Blanks"
          showStatus={tab === QUESTION_VIEW}
          onClose={() => {
            setTab(INDIVIDUAL_VIEW);
            onClose();
          }}
        />
      }
      tabsContent={
        <ClassroomAnswerTabs
          isPublished
          includeIndividualAnswers
          includeSuggestedAnswers={
            !!(
              suggestedAnswerProperties?.suggestedAnswerType ===
                SUGGESTED_ANSWER_VARY ||
              (suggestedAnswerProperties?.suggestedAnswers &&
                suggestedAnswerProperties.suggestedAnswers.length > 0)
            )
          }
          includeClassResponse={false}
          tab={tab}
          onSelect={option => setTab(option)}
          componentId={id}
          onCloseActivitySheet={() => {
            setTab(INDIVIDUAL_VIEW);
            onClose();
          }}
        />
      }
    >
      <ActivitySheetInnerContent id="content">
        {tab === QUESTION_VIEW &&
          subActivityProperties?.activityComponentId && (
            <ActivitySheetInnerMax>
              <ClassroomAnswerInstruction>
                <SubActivityView
                  withTTSButton
                  componentId={id}
                  componentType={type}
                  subActivityDetails={subActivityProperties}
                >
                  <FillInBlanksViewRespond {...props} />
                </SubActivityView>
              </ClassroomAnswerInstruction>
            </ActivitySheetInnerMax>
          )}
        {tab === INDIVIDUAL_VIEW && (
          <ActivitySheetGridMax>
            <FillInBlanksIndividual {...props} />
          </ActivitySheetGridMax>
        )}
        {tab === SUGGESTED_VIEW && (
          <ActivitySheetInnerMax>
            <FillInBlanksSuggestedAnswers {...props} />
          </ActivitySheetInnerMax>
        )}
      </ActivitySheetInnerContent>
    </ActivitySheet>
  );
};

export default FillInBlanksClassAnswers;
